import { ListValue } from "../../ListValue";

export class ClaimCategory {
  static List(): ListValue[] {
    let list: ListValue[] = [
      { id: "CenterManagement", name: "center_management" },
      { id: "ManualImportManagement", name: "manual_import_management" },
      { id: "MemberManagement", name: "member_management" },
      { id: "OrganizationManagement", name: "organization_management" },
      { id: "OrganizationWizard", name: "organization_wizard" },
      { id: "AccountSubscription", name: "account_subscription" },
      { id: "PatientManagement", name: "patient_management" },
      { id: "PatientSubscription", name: "patient_subscription" },
      {
        id: "PatientProcedureManagement",
        name: "patient_procedure_management",
      },
      {
        id: "ProcedureProtocolManagement",
        name: "procedure_protocol_management",
      },
      { id: "UnsubscriptionManagement", name: "unsubscription_management" },
      { id: "ReferralManagement", name: "referral_management" },
      { id: "PerformanceReports", name: "performance_reports" },
      {
        id: "DataExportPatientResponses",
        name: "data_export_patient_responses",
      },
      {
        id: "DataExportPatientFeedbacks",
        name: "data_export_patient_feedbacks",
      },
      { id: "DataExportAlerts", name: "data_export_alerts" },
      { id: "DataExportNotes", name: "data_export_notes" },
      { id: "DataExportDeliverySms", name: "data_export_delivery_sms" },
      { id: "DataExportDeliveryEmail", name: "data_export_delivery_email" },
      { id: "PatientCommunications", name: "patient_communications" },
      { id: "MemberManagementRole", name: "member_management_role" },
      { id: "Recalls", name: "recalls" },
      { id: "AftercareDashboardView", name: "aftercare_dashboard_view" },
      { id: "PatientUpload", name: "patient_upload" },
      { id: "ImportResults", name: "import_results" },
      { id: "ApplicationSecret", name: "application_secret" }
    ];

    return list;
  }

  static Name(id: string): string {
    let rtn: string = "";

    ClaimCategory.List().forEach((obj) => {
      if (obj.id == id) {
        rtn = obj.name;
      }
    });

    return rtn;
  }

  static Value(name: string): string {
    let rtn: string = "";

    ClaimCategory.List().forEach((obj) => {
      if (obj.name == name) {
        rtn = obj.id;
      }
    });

    return rtn;
  }
}
